import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/sign-up')({
  component: SignUpPage,
})

function SignUpPage() {
  const navigate = useNavigate()

  useEffect(() => {
    void navigate({ to: '/', replace: true })
  }, [navigate])

  return null
}
